const YEAR = new Date().getFullYear();

export const translations = {
  bg: {
    nav: {
      links: [
        { label: 'ИСТОРИЯ', href: '#story' },
        { label: 'ТЕРРОАР', href: '#terroir' },
        { label: 'ВИНА', href: '#wines' },
        { label: 'ФИЛОСОФИЯ', href: '#philosophy' },
      ],
      cta: 'СВЪРЖИ СЕ С НАС',
      mobileFooter: 'Североизточно Черноморие · България',
    },
    hero: {
      tagline: 'Където дивото среща традицията.',
      subtitle: 'СЕВЕРОИЗТОЧНО ЧЕРНОМОРИЕ · БЪЛГАРИЯ · БЕЛИ ВИНА',
      cta1: 'РАЗГЛЕДАЙ ВИНАТА',
      cta2: 'СВЪРЖИ СЕ С НАС',
    },
    intro: {
      label: 'ИМОТЪТ',
      heading: 'Двадесет и пет декара земя, която не търпи бързане.',
      body: 'Отглеждаме Тамянка, Пино Гри, Совиньон Блан и Шардоне на органична земя край Здравец — четири сорта, един богат терроар, нищо добавено.',
    },
    story: {
      label: 'НАШАТА ИСТОРИЯ',
      heading: ['Някои неща не се избират.', 'Те се познават.'],
      para1: 'Земята беше изоставена, когато я намерихме. Дива по начина, по който дивее земята, когато дълго време не е поглеждана.',
      para2: 'Не дойдохме с план. Дойдохме с усещане — тук има нещо, което си струва да се запази. Тук останахме. Изчиствахме забравени ниви. Засаждахме. Губихме реколти от слани и наводнения и започвахме отначало, без да правим особено събитие от това.',
      para3: 'Лозята дойдоха накрая. След като всичко останало ни беше научило какво всъщност означава търпение. Тогава не подозирахме, че те всъщност бяха едно ново начало.',
      closing: 'Това, което расте тук, расте бавно. Не въпреки земята — заради нея.',
      caption: 'Езерото на имота · Здравец, България',
    },
    terroir: {
      label: 'ТЕРРОАР И МЯСТО',
      heading: ['Едно езеро, тераси', 'и лек черноморски бриз.'],
      para1: 'Лозята ни се намират край с. Здравец, на по-малко от 20 км от Североизточното Черноморие. Морето укротява климата — смекчава летните жеги, забавя узряването и оставя плода да изгради прецизност, а не тегло.',
      para2: 'Имотът е организиран около малко езеро — с парцели от двете страни, изкачващи се на тераси над водата. Крайезерните лозя са открити и щедри. Терасираните — по-постни, по-минерални, по-съсредоточени.',
      para3: 'Заедно двете изражения дават на вината ни техния обхват — и техния характер.',
      stats: [
        { label: 'РЕГИОН', value: 'Североизточно Черноморие' },
        { label: 'ПОЧВА', value: 'Варовита, алкална' },
        { label: 'ПЛОЩ', value: '25 декара' },
        { label: 'ПАРЦЕЛИ', value: 'Крайезерни и терасирани' },
      ],
    },
    wines: {
      label: 'ВИНАТА',
      heading: ['Четири сорта.', 'Един имот.'],
      intro: 'Винифицираме всеки сорт поотделно — не за да наложим стил, а за да запазим това, което мястото е дало. Това са бели вина, които говорят за откъдето идват.',
      cta: 'ПОПИТАЙ ЗА ВИНАТА',
      wines: [
        {
          numeral: 'I',
          variety: 'Мускат Бланко',
          local: 'Тамянка',
          description: 'Деликатни цветя, цитрусов цвят и ароматна прецизност, която идва от незабързаното узряване до езерото. Най-изразителният и ухаещ сорт на имота.',
          notes: 'АРОМАТЕН · ФЛОРАЛЕН · СВЕЖ',
        },
        {
          numeral: 'II',
          variety: 'Пино Гри',
          local: 'Пино Гри',
          description: 'Закръглен и текстуриран, с тиха богатост. Крайезерните парцели дават тяло; варовитите почви от терасите — структура и сдържаност.',
          notes: 'ТЕКСТУРИРАН · ЩЕДЪР · ПРЕЦИЗЕН',
        },
        {
          numeral: 'III',
          variety: 'Совиньон Блан',
          local: 'Совиньон Блан',
          description: 'Прецизен и минерален. Свеж цитрус, зелен билков нюанс и чист финал, отразяващ по-стегнатия характер на терасираните парцели.',
          notes: 'МИНЕРАЛЕН · ПРЕЦИЗЕН · ЖИВ',
        },
        {
          numeral: 'IV',
          variety: 'Шардоне',
          local: 'Шардоне',
          description: 'Балансиран и воден от мястото. Винифициран така, че земята да говори вместо сорта. Структуриран, измерен, честен.',
          notes: 'СТРУКТУРИРАН · БАЛАНСИРАН · ЗАЗЕМЕН',
        },
      ],
    },
    philosophy: {
      label: 'ФИЛОСОФИЯ И ПРАКТИКА',
      heading: ['Грижа,', 'не удобство.'],
      para1: 'Двадесет и пет декара, обработвани изцяло на ръка. Без хербициди. Без пестициди. Без преки пътища.',
      para2: 'Фермерстваме органично и прилагаме регенеративни принципи към управлението на почвата. Фокусът ни е върху здравето на земята като дългосрочна инвестиция — изграждане на биологичен живот, подобряване на структурата и запазване на минералния характер на терена.',
      para3: 'Беритбата е прецизна. Гроздето се охлажда веднага след набирането — за да защитим това, което вегетационният сезон е изградил.',
      closing: 'Не бързаме. Земята ни е научила на търпение.',
      principles: [
        { label: 'ЗЕМЕДЕЛИЕ', value: 'Сертифицирано органично' },
        { label: 'МЕТОД', value: 'Регенеративно земеделие' },
        { label: 'РЕЗИТБА', value: 'Симоник и Сирх' },
        { label: 'СУРОВИНИ', value: 'Без хербициди и пестициди' },
        { label: 'БЕРИТБА', value: 'Ръчна, прецизно избрана' },
        { label: 'ОХЛАЖДАНЕ', value: 'Незабавно след беритба' },
      ],
    },
    symbol: {
      label: 'СИМВОЛЪТ',
      heading: 'Безкрайният възел',
      para1: 'Нашият знак е древен символ на цялостност, приемственост и взаимосвързаност — познат като Безкрайния възел или Небесната костенурка в различни традиции. Няма начало. Няма край.',
      para2: 'За нас той говори за връзката между земя и време. За онова, което се гради бавно, с търпение. За корените, издръжливостта и принципа на взаимозависимост — между лоза, почва и хората, които се грижат за тях.',
      plantLabel: 'Geranium Bohemicum',
      plantNote: 'Растение, което поникна след пожар, там където малко друго се вкоренява. Расте край Здравец, там където стои нашият имот. Тихо, устойчиво и точно на своето място.',
    },
    contact: {
      label: 'ЗАПИТВАНИЯ',
      scriptHeading: 'Свържете се с нас',
      heading: 'Приемаме кореспонденция.',
      body: 'Независимо дали сте специалист в областта на виното, любопитен дегустатор или просто искате да разберете повече за имота — пишете ни. Отговаряме лично.',
      emailLabel: 'Имейл',
      phoneLabel: 'Телефон',
      locationLabel: 'Местоположение',
      locationValue: 'В близост до Здравец, Североизточно Черноморие, България',
      nameLabel: 'Имена *',
      namePlaceholder: 'Вашите имена',
      emailInputLabel: 'Имейл *',
      emailPlaceholder: 'вашият@имейл.com',
      phoneInputLabel: 'Телефон (по желание)',
      phonePlaceholder: '+359 ...',
      reasonLabel: 'Причина *',
      reasonPlaceholder: 'Изберете причина',
      reasons: ['Общо запитване', 'Търговия / на едро', 'Преса и медии', 'Посещение на имота', 'Друго'],
      messageLabel: 'Съобщение *',
      messagePlaceholder: 'Вашето съобщение...',
      submitIdle: 'ИЗПРАТИ ЗАПИТВАНЕ',
      submitLoading: 'Изпращане...',
      successHeading: 'Благодарим ви.',
      successBody: 'Вашето запитване е получено. Ще отговорим лично.',
      successReset: 'Изпрати ново съобщение',
      errorMsg: 'Нещо се обърка. Моля, опитайте отново.',
    },
    footer: {
      brandLocation: 'Здравец · България',
      proprietor: 'Ioan Gospodinov, Собственик',
      copyright: `© ${YEAR} Geranium Bohemicum. Всички права запазени.`,
      links: [
        { label: 'ИСТОРИЯ', href: '#story' },
        { label: 'ТЕРРОАР', href: '#terroir' },
        { label: 'ВИНА', href: '#wines' },
        { label: 'ФИЛОСОФИЯ', href: '#philosophy' },
        { label: 'СВЪРЖИ СЕ С НАС', href: '#contact' },
      ],
    },
  },

  en: {
    nav: {
      links: [
        { label: 'STORY', href: '#story' },
        { label: 'TERROIR', href: '#terroir' },
        { label: 'WINES', href: '#wines' },
        { label: 'PHILOSOPHY', href: '#philosophy' },
      ],
      cta: 'GET IN TOUCH',
      mobileFooter: 'Northeastern Black Sea · Bulgaria',
    },
    hero: {
      tagline: 'Where the wild meets tradition.',
      subtitle: 'NORTHEASTERN BLACK SEA · BULGARIA · WHITE WINES',
      cta1: 'EXPLORE THE WINES',
      cta2: 'GET IN TOUCH',
    },
    intro: {
      label: 'THE ESTATE',
      heading: 'Twenty-five acres of land that does not tolerate hurry.',
      body: 'We grow Muscat Blanc, Pinot Gris, Sauvignon Blanc and Chardonnay on organic land near the village of Zdravets — four varieties, one rich terroir, nothing added.',
    },
    story: {
      label: 'OUR STORY',
      heading: ['Some things are not chosen.', 'They are recognised.'],
      para1: 'The land was abandoned when we found it. Wild in the way land grows wild when no one has looked at it for a long time.',
      para2: "We didn't arrive with a plan. We arrived with a feeling — that there was something here worth preserving. So we stayed. We cleared forgotten fields. We planted. We lost harvests to frost and floods and started again without making much of it.",
      para3: "The vines came last. After everything else had taught us what patience actually means. We didn't know then that they would turn out to be a new beginning.",
      closing: 'What grows here grows slowly. Not in spite of the land — because of it.',
      caption: 'The estate lake · Zdravets, Bulgaria',
    },
    terroir: {
      label: 'TERROIR & PLACE',
      heading: ['A lake, terraces,', 'and a gentle sea breeze.'],
      para1: 'Our vineyards lie near the village of Zdravets, less than 20km from the Northeastern Black Sea coast. The sea tempers the climate — softening summer heat, slowing ripening, and allowing the fruit to build precision rather than weight.',
      para2: 'The estate is organised around a small lake, with parcels on both sides rising up on terraces above the water. The lakeside vineyards are open and generous. The terraced ones — leaner, more mineral, more focused.',
      para3: 'Together, these two expressions give our wines their range — and their character.',
      stats: [
        { label: 'REGION', value: 'Northeastern Black Sea' },
        { label: 'SOIL', value: 'Calcareous, Alkaline' },
        { label: 'AREA', value: '25 Decares' },
        { label: 'PARCELS', value: 'Lakeside & Terraced' },
      ],
    },
    wines: {
      label: 'THE WINES',
      heading: ['Four varieties.', 'One estate.'],
      intro: 'We vinify each variety separately — not to impose a style, but to preserve what the site gave us. These are white wines that speak of where they come from.',
      cta: 'ENQUIRE ABOUT THE WINES',
      wines: [
        {
          numeral: 'I',
          variety: 'Muscat Blanc',
          local: 'Tamyanka',
          description: "Delicate florals, citrus blossom and an aromatic precision that comes from unhurried ripening beside the lake. The estate's most expressive and fragrant variety.",
          notes: 'AROMATIC · FLORAL · FRESH',
        },
        {
          numeral: 'II',
          variety: 'Pinot Gris',
          local: 'Pinot Gris',
          description: 'Rounded and textured, with a quiet richness. The lakeside parcels lend body; the calcareous terraced soils bring structure and restraint.',
          notes: 'TEXTURED · GENEROUS · PRECISE',
        },
        {
          numeral: 'III',
          variety: 'Sauvignon Blanc',
          local: 'Sauvignon Blanc',
          description: 'Precise and mineral. Fresh citrus, a green herbal edge and a clean finish that reflects the tighter character of the terraced parcels.',
          notes: 'MINERAL · PRECISE · VIVID',
        },
        {
          numeral: 'IV',
          variety: 'Chardonnay',
          local: 'Chardonnay',
          description: 'Balanced and site-driven. Vinified to let the land speak rather than the variety. Structured, measured, honest.',
          notes: 'STRUCTURED · BALANCED · GROUNDED',
        },
      ],
    },
    philosophy: {
      label: 'PHILOSOPHY & PRACTICE',
      heading: ['Care,', 'not convenience.'],
      para1: 'Twenty-five decares, tended entirely by hand. No herbicides. No pesticides. No shortcuts.',
      para2: 'We farm organically and apply regenerative principles to soil management. Our focus is on soil health as a long-term investment — building biological life, improving structure, and preserving the mineral character of the land.',
      para3: 'Harvest timing is precise. Grapes are chilled immediately after picking — to protect what the growing season built.',
      closing: 'We are not in a hurry. The land has taught us patience.',
      principles: [
        { label: 'FARMING', value: 'Certified Organic' },
        { label: 'METHOD', value: 'Regenerative Agriculture' },
        { label: 'PRUNING', value: 'Simonit & Sirch' },
        { label: 'INPUTS', value: 'No Herbicides or Pesticides' },
        { label: 'HARVEST', value: 'Hand-Picked, Precision Timed' },
        { label: 'COOLING', value: 'Immediate Post-Harvest' },
      ],
    },
    symbol: {
      label: 'THE SYMBOL',
      heading: 'The Endless Knot.',
      para1: 'Our emblem is an ancient symbol of integrity, continuity and interconnection — known as the Endless Knot or the Celestial Tortoise across different traditions. It has no beginning and no end.',
      para2: 'For us, it speaks to the relationship between land and time. To what is built slowly, with patience. To roots, endurance, and the enduring principle of interconnection — between vine, soil, and the people who tend them.',
      plantLabel: 'Geranium Bohemicum',
      plantNote: 'Geranium Bohemicum — a plant that emerges after fire, in conditions where little else takes root. It grows near Zdravets, where our estate stands. Quiet, resilient, and precisely where it belongs.',
    },
    contact: {
      label: 'INQUIRIES',
      scriptHeading: 'Get in touch',
      heading: 'We welcome correspondence.',
      body: 'Whether you are a wine professional, a curious taster, or someone looking to know more about the estate — reach out. We respond personally.',
      emailLabel: 'Email',
      phoneLabel: 'Phone',
      locationLabel: 'Location',
      locationValue: 'Near Zdravets, Northern Black Sea, Bulgaria',
      nameLabel: 'Name *',
      namePlaceholder: 'Your name',
      emailInputLabel: 'Email *',
      emailPlaceholder: 'your@email.com',
      phoneInputLabel: 'Phone (optional)',
      phonePlaceholder: '+1 234 567 8900',
      reasonLabel: 'Reason *',
      reasonPlaceholder: 'Select a reason',
      reasons: ['General inquiry', 'Trade / wholesale', 'Press & media', 'Visit the estate', 'Other'],
      messageLabel: 'Message *',
      messagePlaceholder: 'Your message...',
      submitIdle: 'SEND INQUIRY',
      submitLoading: 'Sending...',
      successHeading: 'Thank you.',
      successBody: 'Your inquiry has been received. We will respond personally.',
      successReset: 'Send another message',
      errorMsg: 'Something went wrong. Please try again.',
    },
    footer: {
      brandLocation: 'Zdravets · Bulgaria',
      proprietor: 'Ioan Gospodinov, Proprietor',
      copyright: `© ${YEAR} Geranium Bohemicum. All rights reserved.`,
      links: [
        { label: 'STORY', href: '#story' },
        { label: 'TERROIR', href: '#terroir' },
        { label: 'WINES', href: '#wines' },
        { label: 'PHILOSOPHY', href: '#philosophy' },
        { label: 'GET IN TOUCH', href: '#contact' },
      ],
    },
  },
};
